module.exports = __webpack_public_path__ + "img/button.47558241.png";